import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import { CloseIcon } from '@calendly/ui/components/icons';
import { Sheet } from '@calendly/ui/components/sheet';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const wrapperIsPhoneCss = "w17wrb93";
const wrapperCss = "wyepkmv";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, {
    [wrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const goToLinkCss = "g6iphe6";
const GoToLink = forwardRef((props, ref) => {
  const as = 'a';
  return <BareButton ref={ref} {...props} as={as} className={classNames(goToLinkCss, props.className)} />;
});
const flexWrapperIsPhoneCss = "fdlfym6";
const flexWrapperCss = "f10r6cuo";
const FlexWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(flexWrapperCss, {
    [flexWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const logoBlockCss = "lzgy4cu";
const LogoBlock = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(logoBlockCss, props.className)} />;
});
const modalContentIsPhoneCss = "m7mohjg";
const modalContentCss = "m1jdeevh";
const ModalContent = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <Sheet ref={ref} {...props} className={classNames(modalContentCss, {
    [modalContentIsPhoneCss]: isPhone
  }, props.className)} />;
});
const closeIconButtonCss = "c5tjttc";
const CloseIconButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} aria-label={I18n.t('publisher.action.close')} className={classNames(closeIconButtonCss, props.className)}>
    <CloseIcon />
  </BareButton>);
const closeButtonCss = "c6w6d5n";
const CloseButton = forwardRef((props, ref) => {
  const decoration = 'ghost';
  const responsive = false;
  return <Button ref={ref} {...props} decoration={decoration} responsive={responsive} className={classNames(closeButtonCss, props.className)}>
      {I18n.t('publisher.action.close')}
    </Button>;
});
const headerIsPollCss = "hp7c4bl";
const headerIsPhoneCss = "h1bwf2r";
const headerCss = "hc2gmqp";
const Header = forwardRef((props, ref) => {
  const {
    isPoll,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(headerCss, {
    [headerIsPollCss]: isPoll,
    [headerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const bodyIsPhoneCss = "bz1euh0";
const bodyCss = "bzwgsfa";
const Body = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(bodyCss, {
    [bodyIsPhoneCss]: isPhone
  }, props.className)} />;
});
const bodyContentIsPhoneCss = "b1afkf86";
const bodyContentCss = "b18198eu";
const BodyContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(bodyContentCss, {
    [bodyContentIsPhoneCss]: isPhone
  }, props.className)} />;
});
const footerIsPhoneCss = "f20yeun";
const footerCss = "f16zo1rg";
const Footer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(footerCss, {
    [footerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const readonlyLinkTextCss = "r1eqr9l1";
const ReadonlyLinkText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(readonlyLinkTextCss, props.className)} />;
});
const linkFieldInputIsPhoneCss = "l1tdybm7";
const linkFieldInputCss = "l18hzpx2";
const LinkFieldInput = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'input';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(linkFieldInputCss, {
    [linkFieldInputIsPhoneCss]: isPhone
  }, props.className)} />;
});
const linkFieldWrapperCss = "l1p2201i";
const LinkFieldWrapper = forwardRef((props, ref) => <Wrapper ref={ref} {...props} className={classNames(linkFieldWrapperCss, {}, props.className)} />);
export { Body, BodyContent, CloseButton, CloseIconButton, FlexWrapper, Footer, GoToLink, Header, LinkFieldInput, LinkFieldWrapper, LogoBlock, ModalContent, ReadonlyLinkText, Wrapper };

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");